import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NbToastrService, NbGlobalPhysicalPosition } from '@nebular/theme';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from '../config.service';
import { HttpserviceService } from './httpservice.service';

@Injectable({
  providedIn: 'root'
})
export class ImpresionetiquetasService implements OnInit {
  private socket: WebSocket;
  private messagesSubject: Subject<MessageEvent>;
  public messages$: Observable<MessageEvent>;
  private url;
  private messageQueue: string[] = [];

  constructor(
      private config: ConfigService,
      private http: HttpserviceService,
      private httpClient: HttpClient,
      private toast: NbToastrService,
    ) {
    this.messagesSubject = new Subject<MessageEvent>();
    this.messages$ = this.messagesSubject.asObservable();
    this.url = this.http.urlwebsockets;
    
  }

  positions= NbGlobalPhysicalPosition;
reintentos=10;
  showToast( position,status, title,message) {
    this.toast.show( message, title,{ position, status });
  }

  
    

  ngOnInit(): void {

    this.url=this.http.urlwebsockets;
    //this.connect();

  }

  private procesarMensajeServidor(mensaje: string): void {
    try {
      const data = JSON.parse(mensaje); // Intenta parsear JSON si el servidor responde en este formato
      console.log('📦 Datos procesados:', data);
      this.showToast(this.positions.TOP_RIGHT, 'warning', "Atención", data.mensaje);
      // Aquí puedes agregar lógica para manejar la respuesta del servidor
      // Por ejemplo, actualizar un estado o mostrar una notificación
    } catch (error) {
      this.showToast(this.positions.TOP_RIGHT, 'warning', "Atención",'⚠️ Error al procesar el mensaje del servidor de impresión');
      console.error('⚠️ Error al procesar el mensaje del servidor:', error);
      console.log('📩 Mensaje sin procesar:', mensaje);
    }
  }

  public connect(): void {
    console.log(WebSocket.OPEN);
    if ((!this.socket)||(this.socket.readyState != 1)) {
      
        this.url = this.http.urlwebsockets;
        this.socket = new WebSocket(this.http.urlwebsockets);

        this.socket.onopen = () => {
          // La conexión está abierta, procesa la cola de mensajes pendientes
          this.messageQueue.forEach(msg => this.socket.send(msg));
          this.messageQueue = []; // Limpia la cola
          this.reintentos=10;
        };
  
        // this.socket.onmessage = (message) => {
        //   this.messagesSubject.next(message);
        // };
  
        // this.socket.onerror = (error) => {
        //   console.error('WebSocket error:', error);
        //   this.messagesSubject.error(error);
        // };
  
        this.socket.onclose = () => {
          console.log('WebSocket connection closed');
          this.messagesSubject.complete();
          console.log('WebSocket closed! Attempting to reconnect...');
          if(this.reintentos>=0){
            setTimeout(() => this.connect(), 1000);
            this.reintentos--;
          }
          // Reconnect or handle closure as needed
        };
        this.socket.onerror = (event: Event) => {
          console.error('Error en WebSocket:', event);
          //this.showToast(this.positions.TOP_RIGHT, 'warning', "Atención", "Error en impresión:"+event);
          
          
        };
        // Evento cuando se recibe un mensaje del servidor
        this.socket.onmessage = (event: MessageEvent) => {
          console.log('📩 Mensaje recibido del servidor:', event.data);
          this.procesarMensajeServidor(event.data);
        };
  

    }
  
  }
    
  /**
   * Envia el payload de impresión al backend, que a su vez hablará con el
   * servidor WebSocket de impresión (ware/impresion/legacyPrint.php).
   */
  private postToBackend(payload: any): void {
    const url = (this.http as any).urlbase + 'ware/impresion/legacyPrint.php';
    const payloadWithCamara = {
      ...payload,
      ...(((this.http as any).idcamara ?? null) ? { idcamara: (this.http as any).idcamara } : {}),
    };
    this.httpClient.post(url, payloadWithCamara).subscribe({
      next: (res: any) => {
        if (!res || res.code !== 1) {
          this.showToast(this.positions.TOP_RIGHT, 'warning', 'Impresión', res?.mensaje || 'Error al enviar a impresión');
        }
      },
      error: (err) => {
        console.error('Error HTTP al enviar a impresión', err);
        this.showToast(this.positions.TOP_RIGHT, 'danger', 'Impresión', 'Error de comunicación con el backend de impresión');
      },
    });
  }

  // Mantener firma pública, pero ahora usando backend HTTP en lugar de WebSocket directo
  public sendMessage(message: string): void {
    let payload: any = null;
    try {
      payload = JSON.parse(message);
    } catch (e) {
      console.error('Mensaje de impresión no es JSON válido', message);
      this.showToast(this.positions.TOP_RIGHT, 'danger', 'Impresión', 'Mensaje de impresión inválido');
      return;
    }
    this.postToBackend(payload);
  }
  

  public imprimepalet(idubicacion: any, idpalet:any, idcamara?: any): void {
    const message = {
      id: idubicacion,
      idubicacion: idubicacion,
      palet: idpalet,
      tipo: 1,
      ...(idcamara != null ? { idcamara } : {}),
    };
    this.postToBackend(message);
  }

  public imprimepaletcliente(idubicacion: any, idpalet:any, idcliente:any, idventa:any): void {
    const message = {
      id: idubicacion,
      paletsalida: idpalet,
      cliente: idcliente,
      idventa: idventa,
    };
    this.postToBackend(message);
  }

  public imprimeentrada(idubicacion: any, identrada:any, idcamara?: any): void {
    const message = {
      id: idubicacion,
      entrada: identrada,
      ...(idcamara != null ? { idcamara } : {}),
    };
    this.postToBackend(message);
  }

  public imprimeAlbaran(idubicacion: any, idsalida: any): void {
    const message = {
      id: idubicacion,
      albaran: idsalida,
    };
    this.postToBackend(message);
  }

  // Optional: Close the WebSocket connection (mantener por compatibilidad, aunque ya no se usa)
  public close(): void {
    if (this.socket && (this.socket.readyState === WebSocket.OPEN || this.socket.readyState === WebSocket.CONNECTING)) {
      this.socket.close();
    }
  }
  ngOnDestroy() {
    // Código a ejecutar cuando el servicio se destruye
    console.log('ImpresionetiquetasService se está destruyendo');
    if (this.socket && (this.socket.readyState === WebSocket.OPEN || this.socket.readyState === WebSocket.CONNECTING)) {
      this.socket.close();
    }
  }
}

/*
import { Component, OnInit, OnDestroy } from '@angular/core';
import { WebsocketService } from './websocket.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  template: `<!-- Template here -->`,
})
export class AppComponent implements OnInit, OnDestroy {
  private messagesSubscription: Subscription;

  constructor(private websocketService: WebsocketService) {}

  ngOnInit() {
    this.websocketService.connect('ws://localhost:9502');
    this.messagesSubscription = this.websocketService.messages$.subscribe({
      next: (message) => {
        console.log('Received message:', message.data);
      },
      error: (error) => console.error('WebSocket error:', error),
      complete: () => console.log('WebSocket connection closed'),
    });
  }

  sendMessage() {
    this.websocketService.sendMessage({ action: 'send', data: 'Hello World' });
  }

  ngOnDestroy() {
    this.messagesSubscription.unsubscribe();
    this.websocketService.close(); // Close WebSocket connection when the component is destroyed
  }
}
*/
